<script>
import Loading from './Loading.vue';
export default {
    name: 'StateWrapper',
    components: { Loading },
    props: ['state'],
    render() {
        if (this.state === 'loading') {
            return <loading />;
        }

        let render = this.$slots.default;

        Object.keys(this.$slots).forEach((slotName) => {
            if (this.state === slotName) render = this.$slots[slotName];
        });

        return render;
    },
};
</script>
